import { VERIFICAR_CUENTA_EJECUTIVO } from '@/helpers/urls';
import { useVerificarCuenta } from '../hooks/useVerificarCuenta';
import { POST } from '@/providers/api';
import { ResUsuarioLogin } from '@/models/respuestas/usuario.model';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@/hooks/redux';
import { login } from '@/redux/slices/usuarioSlice';
import Cookies from 'js-cookie';
import ErrorVerificacion from '../../../plantilla/ErrorVerificacion';
import { Centro, Imagen, PilaH, PilaV, Texto } from '@/components/atomos';
import { CircularProgress, Heading } from '@chakra-ui/react';
import EjecutivoBienvenida from '@/assets/img/ejecutivo_bienvenida.webp';
import { FACTORING } from '@/routes/AppRoutes';
import {
  ERROR,
  EXITO,
  PENDIENTE,
  VERIFICANDO,
} from '../hooks/estadosFormularios';
import PantallaVerificacion from './PantallaVerificacion';
import CargandoPantallaCompleta from '@/components/plantilla/CargandoPantallaCompleta';

const VerificacionEjecutivo = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { resultado, estado, setCaptchaToken } =
    useVerificarCuenta<ResUsuarioLogin>(VERIFICAR_CUENTA_EJECUTIVO, POST);

  const cargarDatos = useCallback(() => {
    Cookies.set('t', resultado?.token);
    const datosStore = { ...resultado };
    delete datosStore.token;
    dispatch(login(datosStore));
  }, [resultado, dispatch]);

  useEffect(() => {
    if (estado === EXITO) {
      cargarDatos();
      setTimeout(() => navigate(FACTORING.OPERACIONES, { replace: true }), 3000);
    }
  }, [estado, cargarDatos, navigate]);

  if (estado === PENDIENTE) {
    return <PantallaVerificacion callback={setCaptchaToken} />;
  }

  if (estado === VERIFICANDO) {
    return (
      <Centro h={'100dvh'} w={'full'}>
        <CargandoPantallaCompleta />
      </Centro>
    );
  }

  if (estado === ERROR) return <ErrorVerificacion />;

  if (estado === EXITO)
    return (
      <Centro h={'100dvh'} flexDirection={'column'}>
        <Imagen
          src={EjecutivoBienvenida}
          h={'50%'}
          alt='bienvenida-persona'
          aspectRatio={'1/1'}
        />
        <PilaV>
          <Heading size={'lg'}>
            ¡Bienvenid
            <Texto as={'span'} color={'bPink.400'}>
              @
            </Texto>{' '}
            <Texto as={'span'} color={'bGreen.600'}>
              {resultado?.nombre}
            </Texto>
            !
          </Heading>
          <PilaH>
            <CircularProgress isIndeterminate color='bPink.400' size={6} />
            <Texto fontSize={'lg'} fontWeight={'medium'}>
              Redirigiendo al inicio...
            </Texto>
          </PilaH>
        </PilaV>
      </Centro>
    );

  return null;
};

export default VerificacionEjecutivo;
